// "What matters to me" sliders. Only axes the student moves (or confirms) are saved as their answer.
export const FIT_AXES = [
  ["prestige", "Reputation and rankings"],
  ["affordability", "Keeping costs down"],
  ["career", "Career prospects"],
  ["campus", "Campus life"],
  ["city", "The city"],
  ["sport", "Sport facilities and teams"],
  ["diversity", "International, diverse community"],
];
export const NEUTRAL_WEIGHT = 5;

// Same rule Realisations uses: explicit provenance, or (pre-provenance) a value that differs from the old wizard preset.
const LEGACY_PRESET = { prestige: 6, affordability: 6, career: 8, campus: 5, city: 6, sport: 3, diversity: 5 };
export function axisStatus(profile, axis) {
  const prov = (profile?.field_provenance || {})[`fit_weights.${axis}`];
  if (prov?.explicitly_answered) return "set";
  const v = (profile?.fit_weights || {})[axis];
  if (typeof v !== "number") return "unset";
  if (!profile?.field_provenance?.[`fit_weights.${axis}`] && v !== LEGACY_PRESET[axis]) return "set_earlier";
  return "default";
}

export function FitWeightsField({ value, profile, onChange }) {
  const w = value || {};
  return (
    <div className="sm:col-span-2 space-y-3" data-testid="profile-fit-weights">
      <p className="text-[12px] text-stone-600">0 = doesn't matter, 10 = matters a lot. Sliders you haven't moved stay as defaults and don't count as your preference.</p>
      {FIT_AXES.map(([axis, label]) => {
        const status = axisStatus(profile, axis);
        const shown = typeof w[axis] === "number" ? w[axis] : NEUTRAL_WEIGHT;
        const id = `profile-fit-${axis}`;
        return (
          <div key={axis} className="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-x-3 gap-y-1">
            <label htmlFor={id} className="text-[13px] text-stone-800">{label}</label>
            <span className="font-mono text-[12px] text-stone-700" data-testid={`${id}-value`}>{shown} / 10</span>
            <input id={id} type="range" min="0" max="10" step="1" value={shown} data-testid={id}
              aria-describedby={`${id}-status`}
              onChange={(e) => onChange({ ...w, [axis]: Number(e.target.value) }, axis)}
              className="col-span-2 w-full accent-[#4C1D95]" />
            <span id={`${id}-status`} data-testid={`${id}-status`} data-status={status} className="col-span-2 text-[11px] text-stone-500">
              {status === "set" && ((profile?.field_provenance || {})[`fit_weights.${axis}`]?.source_surface === "realisations" ? "Set by you (saved from Realisations)" : "Set by you")}
              {status === "set_earlier" && "Set by you earlier"}
              {status === "unset" && "Not set"}
              {status === "default" && (
                <>Default, not set by you.{" "}
                  <button type="button" data-testid={`${id}-confirm`} onClick={() => onChange({ ...w, [axis]: shown }, axis)}
                    className="text-[#4C1D95] underline underline-offset-2">Keep {shown} as my answer</button>
                </>
              )}
            </span>
          </div>
        );
      })}
    </div>
  );
}
